import { PackageIcon, ReceiptIcon } from '@phosphor-icons/react'

import { feeTypes } from '../constants'

export const feeTypeCards = [
  {
    value: feeTypes.flatFee,
    title: 'Coste fijo',
    description: 'Un precio único por devolución, independientemente del número de productos',
    Icon: ReceiptIcon,
  },
  {
    value: feeTypes.perReturnedItem,
    title: 'Por producto devuelto',
    description: 'El precio varía según el número de productos incluidos',
    Icon: PackageIcon,
  },
]

export const feeTypeInputName = 'extra_fee_type'
